import React, {Fragment, useRef, useState} from "react";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import {cartItemInterface} from "../../../shoppingCart/cartItemInterface";
import LookListMainFeatureActionsPopper from "./lookListMainFeatureActionsPopper";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const LookListMainFeatureActionsMoreButton = (props) => {

  const {cartItem, intl} = props;

  const anchorRef = useRef(null);
  const [moreOpened, setMoreOpened] = useState(false);

  const moreButtonClick = () => {
    const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    const showLabel = moreOpened ? "hide" : "show";
    Analytics.sendClickEvent(`${LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemMoreDropdown + showLabel}-${featureLabel}`);

    setMoreOpened(!moreOpened)
  }

  return (
    <Fragment>
      <IconButton aria-label={intl.formatMessage({id:"iconButton.more"})}
                  ref={anchorRef}
                  className={"look-icon look-icon--small" + (moreOpened ? " look-icon--active" : "")}
                  onClick={moreButtonClick}>
        <MoreHorizIcon/>
      </IconButton>
      <LookListMainFeatureActionsPopper cartItem={cartItem}
                                        anchorEl={anchorRef}
                                        moreOpened={moreOpened}
                                        setMoreOpened={setMoreOpened}/>
    </Fragment>
  )
};

LookListMainFeatureActionsMoreButton.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired
}

export default injectIntl(
  LookListMainFeatureActionsMoreButton
)
